/* Hindustan Astro performance layer (Ivan, 4 October 2026, changed the same day at Ivan's request).
   Every phone, tablet and laptop gets the full design: no animation, button effect or artwork is switched off
   for memory, processor cores, data saver, screen size or a frame check. Only work nobody can see is paused,
   and it carries on from where it stopped:
   1. Moving artwork and the star sky run while they are within half a screen of view, the tab is open and no
      opened menu or contact panel covers the whole screen.
   2. Animations pause inside page sections more than 30% of a screen away, and run again before they arrive (THE WEIGHT LAW, 17 October 2026; was a full screen).
   The visitor's own reduced motion setting is the only thing that stops motion: then artwork, star sky
   and cursor use their still versions, and html.cx-lite follows that setting. */
(function () {
  var W = window, D = document, H = D.documentElement, A = W.ART;
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function calm() { return !!(RM && RM.matches); }
  function mirror() { H.classList.toggle('cx-lite', calm()); }
  mirror();
  if (RM) { if (RM.addEventListener) RM.addEventListener('change', mirror); else if (RM.addListener) RM.addListener(mirror); }
  /* the earlier version saved a light mode result for some phones; it is no longer read, so it is cleared */
  try { localStorage.removeItem('cx-perf'); } catch (e) {}
  if (calm() && W.cxSettings) W.cxSettings.cursor = false;

  /* inside the theme editor the page is a frame, so distances are measured from the frame's own view */
  var FRAME = W.top !== W.self;
  function watch(cb, margin) {
    if (FRAME) { try { return new IntersectionObserver(cb, { root: D, rootMargin: margin }); } catch (e) {} }
    return new IntersectionObserver(cb, { rootMargin: margin });
  }

  /* run on() while the element is near the screen and the tab is visible, off() otherwise.
     Also off while an opened menu or contact panel covers the whole screen (html.cx-covered and the "cx:covered"
     event come from assets/c-header.js, 4 October 2026): the page behind cannot be seen then, and it carries on
     in the same frame the panel starts to close. */
  var gates = [];
  function gate(el, on, off) {
    var g = { near: false, act: false };
    g.sync = function () { var want = g.near && !D.hidden && !H.classList.contains('cx-covered'); if (want !== g.act) { g.act = want; if (want) on(); else off(); } };
    var io = watch(function (es) { g.near = es[es.length - 1].isIntersecting; g.sync(); }, '50% 0px');
    io.observe(el);
    gates.push(g);
    return function () { io.disconnect(); g.near = false; g.sync(); var i = gates.indexOf(g); if (i > -1) gates.splice(i, 1); };
  }
  function resync() { for (var i = 0; i < gates.length; i++) gates[i].sync(); }
  D.addEventListener('visibilitychange', resync);
  D.addEventListener('cx:covered', resync);

  /* 1. artwork near the screen only; leaving pauses it in place and coming back resumes it */
  if (A && !A._gated && W.IntersectionObserver) {
    A._gated = 1;
    var rawFor = A.artFor;
    A.artFor = function (type, still) { return rawFor(type, still || calm()); };
    var rawArt = A.animateArt;
    A.animateArt = function (root) {
      var cur = null, dead = false;
      var end = gate(root, function () {
        if (dead) return;
        if (cur) { if (cur.start) cur.start(); return; }
        try { cur = rawArt(root); } catch (e) { dead = true; }
      }, function () { if (cur) cur.stop(); });
      return { stop: function () { dead = true; end(); if (cur) cur.stop(); } };
    };
    var rawStars = A.Stars;
    A.Stars = function (canvas) {
      var sky = null, end = null;
      return {
        start: function () {
          if (end) return;
          end = gate(canvas, function () { if (!sky) sky = rawStars(canvas); sky.start(); }, function () { if (sky) sky.stop(); });
        },
        stop: function () { if (end) { end(); end = null; } }
      };
    };
  }

  /* 2. pause animations in sections more than a screen away (the pause rule is in snippets/c-perf-boot.liquid) */
  if (W.IntersectionObserver) {
    var ZONE = 'main > *, .shopify-section-group-c-footer-group';
    /* 20 October 2026 (THE COMPETITOR LOCK): a paused loop still keeps its own compositor layer, and every frame anywhere on the page
       re-counts every layer (309 on the home page, 99 of them the hero's dust far above the founder section). So a section that is far
       away does not pause its never-ending loops, it stops them (animation none, no will-change) and the layers are freed; they start
       again from their first frame as the section comes back, 30% of a screen before it is seen. One-time animations are not touched. */
    if (!D.getElementById('cx-loopcss')) { var lst = D.createElement('style'); lst.id = 'cx-loopcss';
      lst.textContent = '.cx-off [data-cx-loop],.cx-off [data-cx-loop]::before,.cx-off [data-cx-loop]::after{animation:none!important}.cx-off,.cx-off *,.cx-off ::before,.cx-off ::after{will-change:auto!important}';
      D.head.appendChild(lst); }
    function loops(sec) {
      if (!D.getAnimations) return;
      D.getAnimations().forEach(function (a) {
        var ef = a.effect, t = ef && ef.target;
        if (!t || t.nodeType !== 1 || !sec.contains(t) || t.hasAttribute('data-cx-loop')) return;
        try { if (ef.getTiming().iterations === Infinity) t.setAttribute('data-cx-loop', ''); } catch (x) {}
      });
    }
    var far = watch(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) loops(e.target); e.target.classList.toggle('cx-off', !e.isIntersecting); });
    }, '30% 0px'); /* THE WEIGHT LAW (17 October 2026): loops pause 30% of a screen away (was a full screen), so an old phone runs only what is about to be seen */
    D.querySelectorAll(ZONE).forEach(function (el) { far.observe(el); });
    /* theme editor: sections added or reloaded are watched too */
    D.addEventListener('shopify:section:load', function (e) { var t = e.target; if (t && t.matches && t.matches(ZONE)) far.observe(t); });
    D.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.nodeType === 1) far.unobserve(e.target); });
  }
})();
